import _ from 'lodash';
import React, { Fragment } from 'react';

import { LocalTimestamp } from 'src/components/timestamp/Timestamp';
import { date } from 'src/lib/date/date';
import { Resolution } from 'src/lib/graphqlTypes/types';

import { LineChartDataRecord } from './LineChart';

export type LineChartTooltipProps = {
  title?: string;
  formatValue?: (
    axis: 'major' | 'minor',
    value: number,
    maxValue: number,
  ) => string;
  value?: LineChartDataRecord;
  resolution?: Resolution;
  allStacks?: {
    stacks: {
      colorGradientTop: string;
      colorGradientBottom: string;
      primaryColor: string;
      label: string;
      stackId: number;
      unit: string;
    }[];
    axis: 'major' | 'minor';
    maxYValue: number;
    activeStackCounts: {
      value: number;
      label: string;
      stackId: number;
    }[];
  }[];
};

export const LineChartTooltip = ({
  allStacks = [],
  formatValue = (_axis, value) => String(value),
  value = {
    timestamp: new Date(),
    majorStackCounts: [],
    minorStackCounts: [],
  },
  resolution = Resolution.R1D,
}: LineChartTooltipProps) => {
  return (
    <>
      {allStacks.map((axis) => (
        <Fragment key={axis.axis}>
          {axis.activeStackCounts.map(({ stackId }) => {
            const { label, unit } = axis.stacks[stackId] ?? {};
            return (
              <strong key={stackId} className="block">
                {label ? `${label}: ` : ''}
                {formatValue(
                  axis.axis,
                  value[`${axis.axis}StackCounts`][stackId]?.value ?? 0,
                  axis.maxYValue,
                )}
                {unit}
              </strong>
            );
          })}
        </Fragment>
      ))}
      <div className="text-xs">
        Time range:{' '}
        <LocalTimestamp withTooltip={false} value={value.timestamp} /> -{' '}
        <LocalTimestamp
          withTooltip={false}
          value={date.incrementByResolution(value.timestamp, resolution)}
        />
      </div>
    </>
  );
};
